/**
 * @file index.tsx
 *
 * @fileoverview Renders the default icon for when a job has no logo.
 */
import React from 'react';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';
import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Job } from '~/jobiqo/types/types';
import Image from '~/jobiqo/components/Image';

interface JobTeaserNoLogoIconSlotProps {
  /**
   * The job to render the icon for.
   */
  job: Slottable<Job>;
}

export default function JobTeaserNoLogoIconSlot({
  job,
}: JobTeaserNoLogoIconSlotProps) {
  const { JOBS } = useFrontendConfig();

  return (
    <div
      style={{ width: `${JOBS.JOB_TEASER.LOGO_WIDTH}px`, textAlign: 'center' }}
    >
      <Image
        alt={'Contactcenterjobs icon'}
        src={'/static/images/target.png'}
        width={640}
        height={400}
      />
    </div>
  );
}
export { JobTeaserNoLogoIconSlot };
